export const canadianCities = [
  // Alberta
  { value: 'calgary-ab', label: 'Calgary, AB', province: 'ab' },
  { value: 'edmonton-ab', label: 'Edmonton, AB', province: 'ab' },
  { value: 'red-deer-ab', label: 'Red Deer, AB', province: 'ab' },
  { value: 'lethbridge-ab', label: 'Lethbridge, AB', province: 'ab' },
  { value: 'st-albert-ab', label: 'St. Albert, AB', province: 'ab' },
  { value: 'medicine-hat-ab', label: 'Medicine Hat, AB', province: 'ab' },
  { value: 'grande-prairie-ab', label: 'Grande Prairie, AB', province: 'ab' },
  { value: 'airdrie-ab', label: 'Airdrie, AB', province: 'ab' },
  { value: 'spruce-grove-ab', label: 'Spruce Grove, AB', province: 'ab' },
  { value: 'okotoks-ab', label: 'Okotoks, AB', province: 'ab' },
  { value: 'fort-mcmurray-ab', label: 'Fort McMurray, AB', province: 'ab' },
  { value: 'leduc-ab', label: 'Leduc, AB', province: 'ab' },
  { value: 'lloydminster-ab', label: 'Lloydminster, AB', province: 'ab' },
  { value: 'camrose-ab', label: 'Camrose, AB', province: 'ab' },
  { value: 'brooks-ab', label: 'Brooks, AB', province: 'ab' },

  // British Columbia
  { value: 'vancouver-bc', label: 'Vancouver, BC', province: 'bc' },
  { value: 'victoria-bc', label: 'Victoria, BC', province: 'bc' },
  { value: 'kelowna-bc', label: 'Kelowna, BC', province: 'bc' },
  { value: 'abbotsford-bc', label: 'Abbotsford, BC', province: 'bc' },
  { value: 'surrey-bc', label: 'Surrey, BC', province: 'bc' },
  { value: 'burnaby-bc', label: 'Burnaby, BC', province: 'bc' },
  { value: 'richmond-bc', label: 'Richmond, BC', province: 'bc' },
  { value: 'coquitlam-bc', label: 'Coquitlam, BC', province: 'bc' },
  { value: 'saanich-bc', label: 'Saanich, BC', province: 'bc' },
  { value: 'delta-bc', label: 'Delta, BC', province: 'bc' },
  { value: 'kamloops-bc', label: 'Kamloops, BC', province: 'bc' },
  { value: 'nanaimo-bc', label: 'Nanaimo, BC', province: 'bc' },
  { value: 'prince-george-bc', label: 'Prince George, BC', province: 'bc' },
  { value: 'chilliwack-bc', label: 'Chilliwack, BC', province: 'bc' },
  { value: 'maple-ridge-bc', label: 'Maple Ridge, BC', province: 'bc' },
  { value: 'new-westminster-bc', label: 'New Westminster, BC', province: 'bc' },
  { value: 'port-coquitlam-bc', label: 'Port Coquitlam, BC', province: 'bc' },
  { value: 'north-vancouver-bc', label: 'North Vancouver, BC', province: 'bc' },
  { value: 'west-vancouver-bc', label: 'West Vancouver, BC', province: 'bc' },
  { value: 'penticton-bc', label: 'Penticton, BC', province: 'bc' },
  { value: 'vernon-bc', label: 'Vernon, BC', province: 'bc' },
  { value: 'courtenay-bc', label: 'Courtenay, BC', province: 'bc' },
  { value: 'campbell-river-bc', label: 'Campbell River, BC', province: 'bc' },
  { value: 'whistler-bc', label: 'Whistler, BC', province: 'bc' },

  // Manitoba
  { value: 'winnipeg-mb', label: 'Winnipeg, MB', province: 'mb' },
  { value: 'brandon-mb', label: 'Brandon, MB', province: 'mb' },
  { value: 'steinbach-mb', label: 'Steinbach, MB', province: 'mb' },
  { value: 'thompson-mb', label: 'Thompson, MB', province: 'mb' },
  { value: 'portage-la-prairie-mb', label: 'Portage la Prairie, MB', province: 'mb' },
  { value: 'winkler-mb', label: 'Winkler, MB', province: 'mb' },
  { value: 'selkirk-mb', label: 'Selkirk, MB', province: 'mb' },
  { value: 'morden-mb', label: 'Morden, MB', province: 'mb' },

  // New Brunswick
  { value: 'moncton-nb', label: 'Moncton, NB', province: 'nb' },
  { value: 'saint-john-nb', label: 'Saint John, NB', province: 'nb' },
  { value: 'fredericton-nb', label: 'Fredericton, NB', province: 'nb' },
  { value: 'dieppe-nb', label: 'Dieppe, NB', province: 'nb' },
  { value: 'miramichi-nb', label: 'Miramichi, NB', province: 'nb' },
  { value: 'bathurst-nb', label: 'Bathurst, NB', province: 'nb' },
  { value: 'edmundston-nb', label: 'Edmundston, NB', province: 'nb' },

  // Newfoundland and Labrador
  { value: 'st-johns-nl', label: 'St. John\'s, NL', province: 'nl' },
  { value: 'mount-pearl-nl', label: 'Mount Pearl, NL', province: 'nl' },
  { value: 'corner-brook-nl', label: 'Corner Brook, NL', province: 'nl' },
  { value: 'conception-bay-south-nl', label: 'Conception Bay South, NL', province: 'nl' },
  { value: 'paradise-nl', label: 'Paradise, NL', province: 'nl' },
  { value: 'grand-falls-windsor-nl', label: 'Grand Falls-Windsor, NL', province: 'nl' },
  { value: 'gander-nl', label: 'Gander, NL', province: 'nl' },

  // Nova Scotia
  { value: 'halifax-ns', label: 'Halifax, NS', province: 'ns' },
  { value: 'dartmouth-ns', label: 'Dartmouth, NS', province: 'ns' },
  { value: 'sydney-ns', label: 'Sydney, NS', province: 'ns' },
  { value: 'truro-ns', label: 'Truro, NS', province: 'ns' },
  { value: 'new-glasgow-ns', label: 'New Glasgow, NS', province: 'ns' },
  { value: 'glace-bay-ns', label: 'Glace Bay, NS', province: 'ns' },
  { value: 'yarmouth-ns', label: 'Yarmouth, NS', province: 'ns' },

  // Ontario
  { value: 'toronto-on', label: 'Toronto, ON', province: 'on' },
  { value: 'ottawa-on', label: 'Ottawa, ON', province: 'on' },
  { value: 'mississauga-on', label: 'Mississauga, ON', province: 'on' },
  { value: 'brampton-on', label: 'Brampton, ON', province: 'on' },
  { value: 'hamilton-on', label: 'Hamilton, ON', province: 'on' },
  { value: 'london-on', label: 'London, ON', province: 'on' },
  { value: 'markham-on', label: 'Markham, ON', province: 'on' },
  { value: 'vaughan-on', label: 'Vaughan, ON', province: 'on' },
  { value: 'kitchener-on', label: 'Kitchener, ON', province: 'on' },
  { value: 'windsor-on', label: 'Windsor, ON', province: 'on' },
  { value: 'richmond-hill-on', label: 'Richmond Hill, ON', province: 'on' },
  { value: 'oakville-on', label: 'Oakville, ON', province: 'on' },
  { value: 'burlington-on', label: 'Burlington, ON', province: 'on' },
  { value: 'oshawa-on', label: 'Oshawa, ON', province: 'on' },
  { value: 'barrie-on', label: 'Barrie, ON', province: 'on' },
  { value: 'sudbury-on', label: 'Sudbury, ON', province: 'on' },
  { value: 'kingston-on', label: 'Kingston, ON', province: 'on' },
  { value: 'guelph-on', label: 'Guelph, ON', province: 'on' },
  { value: 'cambridge-on', label: 'Cambridge, ON', province: 'on' },
  { value: 'whitby-on', label: 'Whitby, ON', province: 'on' },
  { value: 'ajax-on', label: 'Ajax, ON', province: 'on' },
  { value: 'pickering-on', label: 'Pickering, ON', province: 'on' },
  { value: 'thunder-bay-on', label: 'Thunder Bay, ON', province: 'on' },
  { value: 'waterloo-on', label: 'Waterloo, ON', province: 'on' },
  { value: 'st-catharines-on', label: 'St. Catharines, ON', province: 'on' },
  { value: 'brantford-on', label: 'Brantford, ON', province: 'on' },
  { value: 'niagara-falls-on', label: 'Niagara Falls, ON', province: 'on' },
  { value: 'peterborough-on', label: 'Peterborough, ON', province: 'on' },
  { value: 'sarnia-on', label: 'Sarnia, ON', province: 'on' },
  { value: 'sault-ste-marie-on', label: 'Sault Ste. Marie, ON', province: 'on' },
  { value: 'welland-on', label: 'Welland, ON', province: 'on' },
  { value: 'north-bay-on', label: 'North Bay, ON', province: 'on' },
  { value: 'belleville-on', label: 'Belleville, ON', province: 'on' },
  { value: 'cornwall-on', label: 'Cornwall, ON', province: 'on' },
  { value: 'chatham-kent-on', label: 'Chatham-Kent, ON', province: 'on' },
  { value: 'milton-on', label: 'Milton, ON', province: 'on' },
  { value: 'newmarket-on', label: 'Newmarket, ON', province: 'on' },
  { value: 'aurora-on', label: 'Aurora, ON', province: 'on' },
  { value: 'stouffville-on', label: 'Stouffville, ON', province: 'on' },
  { value: 'georgina-on', label: 'Georgina, ON', province: 'on' },
  { value: 'clarington-on', label: 'Clarington, ON', province: 'on' },

  // Prince Edward Island
  { value: 'charlottetown-pe', label: 'Charlottetown, PE', province: 'pe' },
  { value: 'summerside-pe', label: 'Summerside, PE', province: 'pe' },
  { value: 'stratford-pe', label: 'Stratford, PE', province: 'pe' },
  { value: 'cornwall-pe', label: 'Cornwall, PE', province: 'pe' },

  // Quebec
  { value: 'montreal-qc', label: 'Montréal, QC', province: 'qc' },
  { value: 'quebec-city-qc', label: 'Québec, QC', province: 'qc' },
  { value: 'laval-qc', label: 'Laval, QC', province: 'qc' },
  { value: 'gatineau-qc', label: 'Gatineau, QC', province: 'qc' },
  { value: 'longueuil-qc', label: 'Longueuil, QC', province: 'qc' },
  { value: 'sherbrooke-qc', label: 'Sherbrooke, QC', province: 'qc' },
  { value: 'saguenay-qc', label: 'Saguenay, QC', province: 'qc' },
  { value: 'levis-qc', label: 'Lévis, QC', province: 'qc' },
  { value: 'trois-rivieres-qc', label: 'Trois-Rivières, QC', province: 'qc' },
  { value: 'terrebonne-qc', label: 'Terrebonne, QC', province: 'qc' },
  { value: 'saint-jean-sur-richelieu-qc', label: 'Saint-Jean-sur-Richelieu, QC', province: 'qc' },
  { value: 'repentigny-qc', label: 'Repentigny, QC', province: 'qc' },
  { value: 'brossard-qc', label: 'Brossard, QC', province: 'qc' },
  { value: 'drummondville-qc', label: 'Drummondville, QC', province: 'qc' },
  { value: 'saint-jerome-qc', label: 'Saint-Jérôme, QC', province: 'qc' },
  { value: 'granby-qc', label: 'Granby, QC', province: 'qc' },
  { value: 'blainville-qc', label: 'Blainville, QC', province: 'qc' },
  { value: 'saint-hyacinthe-qc', label: 'Saint-Hyacinthe, QC', province: 'qc' },
  { value: 'shawinigan-qc', label: 'Shawinigan, QC', province: 'qc' },
  { value: 'dollard-des-ormeaux-qc', label: 'Dollard-des-Ormeaux, QC', province: 'qc' },
  { value: 'rimouski-qc', label: 'Rimouski, QC', province: 'qc' },
  { value: 'victoriaville-qc', label: 'Victoriaville, QC', province: 'qc' },
  { value: 'saint-eustache-qc', label: 'Saint-Eustache, QC', province: 'qc' },
  { value: 'mirabel-qc', label: 'Mirabel, QC', province: 'qc' },
  { value: 'mascouche-qc', label: 'Mascouche, QC', province: 'qc' },
  { value: 'beloeil-qc', label: 'Beloeil, QC', province: 'qc' },
  { value: 'chateauguay-qc', label: 'Châteauguay, QC', province: 'qc' },
  { value: 'saint-laurent-qc', label: 'Saint-Laurent, QC', province: 'qc' },
  { value: 'vaudreuil-dorion-qc', label: 'Vaudreuil-Dorion, QC', province: 'qc' },
  { value: 'alma-qc', label: 'Alma, QC', province: 'qc' },
  { value: 'rouyn-noranda-qc', label: 'Rouyn-Noranda, QC', province: 'qc' },
  { value: 'sept-iles-qc', label: 'Sept-Îles, QC', province: 'qc' },

  // Saskatchewan
  { value: 'saskatoon-sk', label: 'Saskatoon, SK', province: 'sk' },
  { value: 'regina-sk', label: 'Regina, SK', province: 'sk' },
  { value: 'prince-albert-sk', label: 'Prince Albert, SK', province: 'sk' },
  { value: 'moose-jaw-sk', label: 'Moose Jaw, SK', province: 'sk' },
  { value: 'swift-current-sk', label: 'Swift Current, SK', province: 'sk' },
  { value: 'yorkton-sk', label: 'Yorkton, SK', province: 'sk' },
  { value: 'north-battleford-sk', label: 'North Battleford, SK', province: 'sk' },
  { value: 'estevan-sk', label: 'Estevan, SK', province: 'sk' },

  // Territories
  { value: 'yellowknife-nt', label: 'Yellowknife, NT', province: 'nt' },
  { value: 'whitehorse-yt', label: 'Whitehorse, YT', province: 'yt' },
  { value: 'iqaluit-nu', label: 'Iqaluit, NU', province: 'nu' }
];

export const getCanadianCitiesByProvince = (provinceCode) => {
  return canadianCities?.filter(city => city?.province === provinceCode);
};

export const getAllCanadianCityOptions = () => {
  return [{ value: 'remote', label: 'Remote (Any Location)' }, ...canadianCities];
};
